import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Row, Col, CardBody, Card, Container } from "reactstrap"

import { getTerms } from "../../crud/auth.crud"
// availity-reactstrap-validation

// Redux

// import images
import logo_long from "assets/images/logo-long.png"

const serviceAgree = () => {

  const [service, setService] = useState()

  const termsArr = [
    { category: 'service' },
    { category: 'privacy' },
    { category: 'terms' },
    { category: 'electronic' },
    { category: 'marketing' },
  ]

  useEffect( async() => {
    const response = await getTerms()
    if (response.status === 200) {
      const service = response.data.results.filter(item => item.category === 'privacy')[0]
      setService(service)
    }
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>회원가입 | 웨이스트버스</title>
      </MetaTags>
      <div className="account-pages my-4 px-1">
        <Col xs={12} sm={9} md={6} style={{margin: '0 auto'}}>
          <img src={logo_long} className="mb-4" />
          <Row className="justify-content-center">
            <Col md={12}>
              <Card className="overflow-hidden">

                  <CardBody className="p-4">
                    <div className="p-3">

                      <div className="mb-3" style={{ marginTop: 24 }}>
                        <p className="noMargin" style={{ fontSize: 18, textAlign: "center", marginBottom: 6 }}>{service?.subject}</p>
                        <div style={{ height: 1, width: '100%', backgroundColor: 'black', marginBottom: 6 }}></div>
                        <div style={{height: '72vh', overflowY: 'scroll'}}>
                          <p className="noMargin" style={{ fontSize: 14, textAlign: "center", marginBottom: 6 }}>{service?.content}</p>
                        </div>
                      </div>

                    </div>
                  </CardBody>

              </Card>
            </Col>
          </Row>
        </Col>
      </div>
    </React.Fragment>
  );
}

export default serviceAgree